import cachedFetch from '../utility-functions/cached-fetch';

const UPDATE_HEADER_URL = '/basket/api/getcurrent';

export const getData = async (cacheBuster: boolean = false) => fetchDataFromServer(cacheBuster);

const fetchDataFromServer = async (cacheBuster: boolean = false) => {
  return cachedFetch(`${UPDATE_HEADER_URL}`, { seconds: 60, cacheBuster, request: { credentials: 'include' } })
    .then((resp) => resp.json())
    .then((json) => {
      return {
        ...json,
        isLoggedIn: /^true$/i.test(json.isLoggedIn)
      };
    });
};
